import clsx from 'clsx';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import Link from 'components/shared/link';
import VideoEmbed from 'components/shared/video-embed';

import ClockIcon from './images/clock.inline.svg';
import PinIcon from './images/pin.inline.svg';

const PostCard = ({
  url,
  cover,
  videoType,
  videoId,
  category,
  title,
  description,
  date,
  publishedAt,
  place,
  className,
}) => (
  <Link
    className={clsx(
      'flex flex-col overflow-hidden md:mx-auto md:min-h-0 md:max-w-[384px]',
      className
    )}
    theme="black"
    to={url}
  >
    {cover && (
      <GatsbyImage
        className={clsx('w-full rounded-lg bg-gray-1', {
          '!hidden lg:!block': videoType && videoId,
        })}
        imgClassName="w-full"
        image={getImage(cover?.localFile)}
        alt={cover?.altText || ''}
      />
    )}
    {videoType && videoId && (
      <VideoEmbed
        className="rounded-lg bg-gray-1 lg:hidden"
        embedId={videoId}
        embedType={videoType}
        videoHeight={216}
        videoWidth={384}
      />
    )}
    <span className="mt-4 flex flex-col items-start justify-start">
      {(category || publishedAt) && (
        <span className="mb-3 text-xs font-medium uppercase leading-none text-gray-7">
          {category || publishedAt}
        </span>
      )}
      {title && (
        <h3 className="text-lg font-bold leading-normal lg:text-[18px] xs:text-[16px]">{title}</h3>
      )}
      {description && (
        <p className="mt-3 text-base leading-normal !text-black line-clamp-2">{description}</p>
      )}
      {(date || place) && (
        <span className="mt-5 flex flex-row items-start justify-start space-x-4">
          {date && (
            <span className="inline-flex flex-row items-center space-x-2">
              <ClockIcon className="h-5 w-5 text-gray-6" />
              <span className="mt-1 text-sm font-normal leading-none text-black">{date}</span>
            </span>
          )}
          {place && (
            <span className="inline-flex flex-row items-center space-x-2">
              <PinIcon className="h-5 w-5 text-gray-6" />
              <span className="mt-1 text-sm font-normal leading-none text-black">{place}</span>
            </span>
          )}
        </span>
      )}
    </span>
  </Link>
);

PostCard.propTypes = {
  url: PropTypes.string.isRequired,
  cover: PropTypes.shape({
    localFile: PropTypes.shape({
      childImageSharp: PropTypes.shape({
        gatsbyImageData: PropTypes.any.isRequired,
      }).isRequired,
    }).isRequired,
    altText: PropTypes.string,
  }),
  videoType: PropTypes.string,
  videoId: PropTypes.string,
  category: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  date: PropTypes.string,
  publishedAt: PropTypes.string,
  place: PropTypes.string,
  className: PropTypes.string,
};

PostCard.defaultProps = {
  cover: null,
  videoType: null,
  videoId: null,
  category: null,
  title: null,
  description: null,
  date: null,
  publishedAt: null,
  place: null,
  className: null,
};

export default PostCard;
